const re = /^open-blocks-panel: <(.+)>$/;

export function parseBlocksPanelAction(id: string) {
  const match = id.match(re);
  return match ? { panelName: match[1] } : undefined;
}
